import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'label'> {
  label?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

export function Checkbox({ label, description, className = '', ...props }: CheckboxProps) {
  const { ...inputProps } = props;
  return (
    <label
      className={`group flex cursor-pointer items-center gap-3 rounded-2xl border border-gray-200 bg-white p-4 transition-all hover:border-lime-900 hover:shadow-sm ${className}`}
    >
      <div className="relative flex h-5 w-5 shrink-0 items-center justify-center mt-0.5">
        <input type="checkbox" className="peer sr-only" {...inputProps} />
        <div className="h-5 w-5 rounded-lg border-2 border-gray-200 bg-white transition-all peer-checked:border-lime-800 peer-checked:bg-lime-800 group-hover:border-gray-300" />
        <Check
          className="absolute h-3.5 w-3.5 text-lime-400 opacity-0 transition-all peer-checked:opacity-100"
          strokeWidth={4}
        />
      </div>
      <div className="flex flex-col gap-0.5">
        {label && <span className={`text-sm font-medium  text-gray-900 group-hover:text-black`}>{label}</span>}
        {description && <span className="desc-sm leading-relaxed">{description}</span>}
      </div>
    </label>
  );
}
